import Promise from 'promise-polyfill';
import Vue from 'vue'
import Vuex from 'vuex'
import Axios from 'axios';
import {cmsURL} from './config'

Vue.use(Vuex);

export default new Vuex.Store({
    strict: process.env.NODE_ENV !== 'production',

    state: {
        activeNavigationItem: "/",
        blogs: [],
        banners: [],
        latest: [],
        blog: null,
        collection: null,
        collections: []
    },

    mutations: {

        addBlogItems(state, blogs) {

            Array.prototype.forEach.call(blogs, function(blog) {

                state.blogs.push(blog);
            });
        },

        setBlogItem(state, blog) {

            state.blog = blog;
        },

        setBanners(state, banners) {

            state.banners = banners;
        },

        addLatestBlogItem(state, blogs) {

            Array.prototype.forEach.call(blogs, function(blog) {

                state.latest.push(blog);
            });
        },

        setLatestBlogItem(state, blog) {

            state.latest = blog;
        },

        setBlogItems(state, blogs) {

            state.blogs = blogs;
        },

        setCollection(state, collection) {

            state.collection = collection;
        },

        setCollections(state, collections) {

            state.collections = collections;
        },

        setActiveNavigationItem(state, path) {

            state.activeNavigationItem = path;
        }

    },

    actions: {

        getBlogItems({commit}, data) {

            return new Promise(function(resolve, reject) {

                jQuery.ajax({
                    url: cmsURL + "blog/getLatest",
                    type: "get",
                    data: {
                        take: data.take,
                        skip: data.skip,
                        exclude: data.exclude
                    },
                    cache: true,
                    dataType: "json",
                    success: function(response) {

                        if(data.override) {

                            commit('setLatestBlogItem', response);

                        } else commit('addLatestBlogItem', response);

                        resolve(data);
                    }
                }).fail(function(error) {

                    console.log("Error getting blog items");
                    console.log(error);
                    console.log(error.responseText);
                    reject(error);
                });


            });
        },

        getCollections({commit}) {

            return new Promise(function(resolve, reject) {

                jQuery.ajax({
                    url: cmsURL + "collection",
                    type: "get",
                    dataType: "json",
                    cache: true,
                    success: function(data) {

                        commit('setCollections', data);

                        resolve(data);
                    }
                }).fail(function(error) {

                    console.log("Error getting collections");
                    console.log(error);
                    console.log(error.responseText);
                    reject(error);
                });
            });
        },

        getCollection({commit}, data) {

            return new Promise(function(resolve, reject) {

                jQuery.ajax({
                    url: cmsURL + "collection/getBySEO/"+data.uri,
                    type: "get",
                    dataType: "json",
                    cache: true,
                    data: {
                        take: data.take,
                        skip: data.skip
                    },
                    success: function(collection) {

                        if(data.override) {

                            commit('setBlogItems', collection.blogs);

                        } else commit('addBlogItems', collection.blogs);

                        commit('setCollection', collection);

                        resolve(collection.blogs);

                    }
                }).fail(function(error) {

                    reject(error);

                    console.log(error);
                    console.log(error.responseText);
                });
            });
        },

        setActiveNavigationItem({commit}, path) {

            commit("setActiveNavigationItem", path);
        },

        loadBlogPost({commit}, data) {

            return new Promise(function(resolve, reject) {

                jQuery.ajax({
                    url: cmsURL + "blog/getBySEO/"+data.id,
                    type: "get",
                    dataType: "json",
                    data: data,
                    cache: true,
                    success: function(response) {

                        commit("setBlogItem", response.blog);
                        resolve(response);
                    }
                }).fail(function(error) {

                    console.log("Error getting blog");
                    console.log(error);
                    console.log(error.responseText);

                    reject(error);
                });

            });
        },

        loadBanners({commit}) {

            return new Promise(function(resolve, reject) {

                jQuery.ajax({
                    url: cmsURL + "banner",
                    type: "get",
                    dataType: "json",
                    cache: true,
                    success: function(banners) {

                        commit('setBanners', banners);

                        resolve(banners);

                    }
                }).fail(function(error) {

                    reject(error);

                    console.log(error);
                    console.log(error.responseText);
                });
            });
        }


    }
});



// WEBPACK FOOTER //
// ./src/store.js